import './PlanCard.css';
import PricingContext from '../../contexts/PricingContext';
import { useContext } from 'react';
import ThemeContext from '../../contexts/ThemeContext';
import {
    $Rate,
    PLAN_SUBSCRIBE_DESTINATION,
    buildPlanLandingLink,
    buildPlanSubscribeLink,
    buildWspTextLink,
} from '../../utils/links';

const PlanCard = ({
    dir,
    txtAlign,
    cur,
    card: { title, price, features },
    plan: {
        tax,
        disclaimer,
        inquiry,
        customPlan,
        btnMsg,
        monthly,
        yearly,
        buymsg,
        afterBuymsg,
    },
    planTypes,
    wspLink,
}) => {
    const { pricingPlan, currentPlan, setCurrentPlan } = useContext(PricingContext);
    const { theme } = useContext(ThemeContext);
    const planName = planTypes.find((p) => p.type === currentPlan)['name'];
    const UAEPrice = Math.ceil(Number((price / $Rate).toFixed(0)) / 50) * 50;
    const isMonthly = pricingPlan === 'monthly';
    const displayPrice = isMonthly
        ? cur === '₪'
            ? price
            : UAEPrice
        : cur === '₪'
          ? (price * 11.5).toFixed(0)
          : ((price * 11.5) / $Rate).toFixed(0);
    const periodLabel = isMonthly ? monthly : yearly;
    const priceLabel = `${cur === '$' ? '$' : '₪'}${displayPrice}`;

    const planContext = {
        buymsg,
        afterBuymsg,
        planName,
        title,
        periodLabel,
        priceLabel,
    };

    const subscribeLink =
        PLAN_SUBSCRIBE_DESTINATION === 'landing'
            ? buildPlanLandingLink(planContext)
            : buildPlanSubscribeLink(wspLink, planContext);

    const inquiryText = `${buymsg} ${planName} - ${title}\n${afterBuymsg}`;
    const inquiryLink = buildWspTextLink(wspLink, inquiryText);

    const openSubscribe = () => window.open(subscribeLink, '_blank');

    return (
        <div
            className={`PlanCard`}
            data-aos={`zoom-in`}
            data-aos-duration="1500"
            style={{ backgroundColor: theme.cardsBg }}
        >
            <div className={`custom-plans`} style={{ direction: 'rtl' }}>
                {planTypes.map((plan) => (
                    <div
                        key={plan.type}
                        className={`custom-plan ${plan.type[0]} fz07rem ${currentPlan === plan.type && 'active'}`}
                        id={plan.type}
                        onClick={(e) => setCurrentPlan(e.target.id)}
                    >
                        {plan.name}
                    </div>
                ))}
            </div>
            <p className="plan-title">{title}</p>
            <h2 className={`plan-price`}>
                <span className="currency">{cur === '$' ? '$' : '₪'}</span>
                {displayPrice}
                <span className={`plan-period`}>{periodLabel}</span>
                {cur === '$' ? '' : <span className={`tax`}>{tax}</span>}
            </h2>
            <ul
                className={`features-list`}
                style={{ textAlign: txtAlign, direction: dir }}
            >
                {features.map((feature, i) => (
                    <li key={i} className={`plan-feature`}>
                        {feature}
                    </li>
                ))}
            </ul>
            {currentPlan === 'both' || currentPlan === 'socialmedia' ? (
                <>
                    <span className="plan-alert">{disclaimer}</span>
                    <a
                        href={inquiryLink}
                        target="_blank"
                        rel="noreferrer"
                        className="get-offer"
                    >
                        {inquiry}
                    </a>
                </>
            ) : (
                <a
                    href={inquiryLink}
                    target="_blank"
                    rel="noreferrer"
                    className="get-offer"
                >
                    {customPlan}
                </a>
            )}
            <button
                type="button"
                onClick={openSubscribe}
                className="scale-in-center btnGradient sub-btn"
                style={{
                    backgroundColor:
                        theme.mode === 'light' ? theme.text : theme.qb,
                }}
            >
                {btnMsg}
            </button>
        </div>
    );
};

export default PlanCard;
